module.exports = __webpack_public_path__ + "static/media/snare.fcea7bf1.mp3";